// Paginado de las tablas de Informes rápidos: cuántas filas caben y qué
// páginas se muestran en «‹ 1 2 … 9 ›». Puro y con tests (pagination.test.ts).

// Filas que caben en `availablePx` debajo de un encabezado de `headerPx`; nunca
// menos de `min`, aunque la tabla tenga que hacer scroll.
export const fitRows = (availablePx: number, rowPx: number, headerPx: number, min = 5) =>
  Math.max(min, Math.floor((availablePx - headerPx) / rowPx) || 0);

// Página actual acotada al rango y el rango visible, «N–M de T».
export const pageInfo = (total: number, size: number, page: number) => {
  const pages = Math.max(1, Math.ceil(total / Math.max(1, size)));
  const current = Math.min(Math.max(0, page), pages - 1);
  const start = current * size;
  const end = Math.min(total, start + size);
  return { pages, page: current, start, end, label: total ? `${start + 1}–${end} de ${total}` : "0 de 0" };
};

// Botones de página (base 0): primera, última y vecinas de la actual; los
// huecos se marcan con "…". Hasta 7 páginas se muestran todas.
export const pageList = (page: number, pages: number): (number | "…")[] => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i);
  const keep = new Set([0, pages - 1, page - 1, page, page + 1]);
  // En las orillas se completan 5 botones seguidos para que el ancho no brinque.
  if (page <= 2) [1, 2, 3].forEach((p) => keep.add(p));
  if (page >= pages - 3) [pages - 4, pages - 3, pages - 2].forEach((p) => keep.add(p));
  const list = [...keep].filter((p) => p >= 0 && p < pages).sort((a, b) => a - b);
  return list.flatMap((p, i) => (i > 0 && p - list[i - 1] > 1 ? (["…", p] as const) : [p]));
};
